import React, { useEffect, useState } from "react";
import api from "../lib/api";
import ContentDetail from "../components/ContentDetail";
import { StatusBadge, DataLabel } from "../components/common";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../components/ui/dialog";
import { NotePencil } from "@phosphor-icons/react";

export default function Drafts() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);

  const load = async () => {
    const [a, b] = await Promise.all([
      api.get("/content?status=draft"),
      api.get("/content?status=changes_requested"),
    ]);
    setItems([...a.data, ...b.data]);
  };
  useEffect(() => { load(); const t = setInterval(load, 10000); return () => clearInterval(t); }, []);

  return (
    <div>
      <div className="mb-6">
        <div className="text-[11px] font-mono uppercase tracking-[0.25em] text-muted-foreground mb-1">À reprendre</div>
        <h1 className="font-serif text-4xl text-brand tracking-tight">Brouillons</h1>
        <p className="text-sm text-muted-foreground mt-1">Contenus conservés pour plus tard ou en attente de correction. Un brouillon n'est jamais publié automatiquement.</p>
      </div>

      {items.length === 0 ? (
        <div className="bg-white border border-border rounded-md p-12 text-center">
          <NotePencil size={28} className="mx-auto text-muted-foreground mb-2" />
          <p className="text-sm text-muted-foreground">Aucun brouillon conservé.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {items.map((c) => (
            <button key={c.id} data-testid={`draft-${c.id}`} onClick={() => setOpen(c.id)}
              className="text-left bg-white border border-border rounded-md p-4 hover:border-brand/40 transition-colors">
              <div className="flex items-center justify-between mb-1.5">
                <span className="text-[10px] font-mono uppercase tracking-wider text-muted-foreground">{c.content_type}</span>
                <StatusBadge status={c.status} />
              </div>
              <div className="text-sm font-medium leading-snug line-clamp-2">{c.title_primary}</div>
              <div className="mt-2 text-[11px] text-muted-foreground">Modifié le {new Date(c.updated_at).toLocaleDateString("fr-FR")}</div>
            </button>
          ))}
        </div>
      )}

      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent className="max-w-6xl max-h-[90vh] overflow-y-auto">
          <DialogHeader className="sr-only"><DialogTitle>Brouillon</DialogTitle>
            <DialogDescription>Relecture et validation du brouillon.</DialogDescription></DialogHeader>
          {open && <ContentDetail contentId={open} onChanged={load} />}
        </DialogContent>
      </Dialog>
    </div>
  );
}
